import api from '../api/apiClient';

export const deleteNode = async (className) => {
  try {
    const response = await api.post(
      `/schema/graph/deleteClass`,
      { class_name: className },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};